import { IContextManager } from '@loglayer/context-manager'
import merge from 'lodash.merge'

type Context = Record<string, any>

export class RootContextManager implements IContextManager {
    private globalContext: Context = {}

    hasContextData = (): boolean => Object.keys(this.globalContext).length > 0

    setContext = (context: Context = {}): void => {
        for (const key in this.globalContext) delete this.globalContext[key]

        merge(this.globalContext, context)
    }

    appendContext = (context: Context): void => void merge(this.globalContext, context)

    getContext = (): Context => merge({}, this.globalContext)

    clone = (): IContextManager => new ChildContextManager(this.globalContext)

    onChildLoggerCreated = (): void => {}
}

class ChildContextManager implements IContextManager {
    private globalContext: Context
    private localContext: Context = {}

    constructor(globalCtx: Context) {
        this.globalContext = globalCtx
    }

    hasContextData = (): boolean => {
        return (
            Object.keys(this.globalContext).length > 0 || Object.keys(this.localContext).length > 0
        )
    }

    setContext = (context: Context = {}): void => {
        for (const key in this.localContext) delete this.localContext[key]

        merge(this.localContext, context)
    }

    appendContext = (context: Context): void => void merge(this.localContext, context)

    getContext = (): Context => merge({}, this.globalContext, this.localContext)

    clone = (): IContextManager => new ChildContextManager(this.getContext())

    onChildLoggerCreated = (): void => {}
}

export const contextManager = new RootContextManager()
